import styled from 'styled-components';

export const Guide = styled.div`
  color: var(--gray-900, #181818);
  font-size: 2.4rem;
  font-weight: 700;
  line-height: 3.6rem;
  letter-spacing: -0.024rem;
`;
export const AssistantGuide = styled.div`
  color: var(--gray-500, #555);
  font-size: 1.6rem;
  line-height: 2.6rem;
  letter-spacing: -0.016rem;
`;
export const Wrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.4rem;
  margin-bottom: 2.4rem;
`;
